'use strict';

ebTextField.$inject = [];

function ebTextField() {
    return {
        restrict: 'E',
        templateUrl: require('./ebTextField.html'),
        scope: {
            required: '=',
            for: '@',
            label: '@',
            placeholder: '@',
            model: '='
        }
    };
}

module.exports = ebTextField;



//////////////////
// WEBPACK FOOTER
// ./source/angular/components/admin/directives/ebTextFieldDirective.js
// module id = 44
// module chunks = 0